import { SET_NOTIFICATIONS, CLEAR_NOTIFICATIONS, DELETE_NOTIFICATIONS } from "../actions/notificationActions";

const initialState = {
  notifications: []
}

function notificationReducer(state = initialState, action) {
  switch (action.type) {
  case SET_NOTIFICATIONS:
    return {
      ...state,
      notifications: [...state.notifications, action.payload]
    }
  case CLEAR_NOTIFICATIONS:
    return {
      ...state,
      notifications: []
    }
  case DELETE_NOTIFICATIONS:
    return {
      ...state,
      notifications: state.notifications.filter((notification, index) => {
        return index !== action.payload
      })
    }
  default:
    return state;
  }
}

export default notificationReducer;